import { admin2 } from '@/api/instance'

//= > 更新會員中心設置
export const GetShopInfo = async ({ shopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/shopInfo`,
  })

  return res
}

//= > 更新會員中心設置
export const UpdateShopInfo = async ({ shopId, contactCustomerLink }) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/shopInfo`,
    data: {
      contactCustomerLink,
    },
  })

  return res
}

//= > 取得店家會員中心設置
export const GetMemberCenterConfig = async ({ shopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/memberCenterConfig`,
  })

  return res
}

//= > 更新會員中心設置
export const UpdateMemberCenterConfig = async ({
  shopId,
  functionMenuSetting,
  footers,
}) => {
  const res = await admin2({
    method: 'put',
    url: `/${shopId}/memberCenterConfig`,
    data: {
      functionMenuSetting,
      footers,
    },
  })

  return res
}

//= > 取得會員中心設置
export const GetAllowFooterNav = async ({ shopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/memberCenterConfig/allowFooters`,
  })

  return res
}

export const GetAllowFuncMenu = async ({ shopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/memberCenterConfig/allowFunctionMenu`,
  })

  return res
}

export const GetIsScanQrcodeValid = async ({ shopId }) => {
  const res = await admin2({
    method: 'get',
    url: `/${shopId}/memberCenterConfig/scanQrcode`,
  })

  return res
}

// 取得會員卡QRCode設置
/**
 * @returns {Promise<[
 *   {
 *     enable: boolean,
 *     type: string,
 *     isExternal: boolean,
 *     externalType: string,
 *     defaultScope: 'member' | 'userInfo' | 'systemCustom',
 *     defaultKey: 'id' | 'phone' | 'email' | 'name'
 *   },
 *   any,
 *   any
 * ]>}
 */
export const GetMemberCenterQRCode = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberCenterQRcode`,
  })
}

// 更新會員卡QRCode設置
/**
 * @param {Object} params
 * @param {string} params.shopId
 * @param {boolean} params.enable
 * @param {string} params.type
 * @param {boolean} params.isExternal
 * @param {string} params.externalType
 * @param {'member' | 'userInfo' | 'systemCustom'} params.defaultScope
 * @param {'id' | 'phone' | 'email' | 'name'} params.defaultKey
 */
export const UpdateMemberCenterQRCode = async ({
  shopId,
  enable,
  type,
  isExternal,
  externalType,
  defaultScope,
  defaultKey,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberCenterQRcode`,
    data: {
      enable,
      type,
      isExternal,
      externalType,
      defaultScope,
      defaultKey,
    },
  })
}

/**
 * 取得會員中心QRCode來源選項
 * @param {Object} param0
 * @param {string} param0.shopId
 * @returns {Promise<Array<{label: string, value: string}>>}
 */
export const GetMemberCenterQRCodeSourceOptions = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberCenterQRcode/sourceOptions`,
  })
}

export const GetClientPageConfig = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/clientPageSetting`,
  })
}

export const UpdateClientPageConfig = async ({
  shopId,
  colorStyle,
  CustomColorStyleId,
  enableLiff,
  clientShortUrls,
  googleAnalyticsMeasurementId,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/clientPageSetting`,
    data: {
      colorStyle,
      CustomColorStyleId,
      enableLiff,
      clientShortUrls,
      googleAnalyticsMeasurementId,
    },
  })
}
// 取得Client頁面設置連結
export const GetClientPageConfigLink = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/clientPageSetting/links`,
  })
}

// 更新會員第三方交易設定
export const UpdateExternalTransactionConfig = async ({
  shopId,
  enableClientDisplayTimeRange,
  clientDisplayTimeRangeStartAt,
  clientDisplayTimeRangeEndAt,
}) => {
  return await admin2({
    method: 'PUT',
    url: `/${shopId}/memberExternalTransactionConfig`,
    data: {
      enableClientDisplayTimeRange,
      clientDisplayTimeRangeStartAt,
      clientDisplayTimeRangeEndAt,
    },
  })
}

// 取得會員第三方交易設定
export const GetExternalTransactionConfig = async ({
  shopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberExternalTransactionConfig`,
  })
}

export const GetMemberCenterCardOptions = async ({ shopId }) => {
  return await admin2({
    method: 'GET',
    url: `/${shopId}/memberCenterConfig/memberCardOptions`,
  })
}
